import React from 'react'

const ServicesPage = () => {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold mb-4">Services Page</h1>
      <p>This is a placeholder for the Services page.</p>
    </div>
  )
}

export default ServicesPage